import { createSelector } from "reselect";
import { getAllSureMotorClaim } from "./index";
import { PAGE_INDICES, PROGRESS_BAR_STEPS } from "../../actions/allSureMotorClaim/types";
import { getAllSureMotorFieldsToBeValidated } from "./referenceData";

export const getRouting = createSelector(
  getAllSureMotorClaim,
  (allSureMotorClaim) => allSureMotorClaim.routing
);
export const getActivePageIndex = createSelector(
  getRouting,
  // getAllSureMotorFieldsToBeValidated,
  (routing) => routing.activePageIndex
);

export const getClaimName = createSelector(
  getRouting,
  (routing) => routing.claimName
);

export const getScrollToId= createSelector(
  getRouting,
  (routing) => routing.scrollToId
);

export const getProgressBarSteps=createSelector( getActivePageIndex,
  (
    activePageIndex
  )=>{
    return PROGRESS_BAR_STEPS.map(
      (step) => ({
          ...step,
          isActive: activePageIndex === PAGE_INDICES[step.key],
          isCompleted: activePageIndex + 1 > PAGE_INDICES[step.key],
      })
  );
  }
)

export const getIsProgressBar = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return ![0,6].includes(activePageIndex) 
  }
);

// used by the application wizard footer
export const getContinueButtonText = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex === PAGE_INDICES.CONFIRMATION
      ? "SUBMIT"
      : "CONTINUE";
  }
);

